import http from '@/communication/AuthConnection'
import {
  navigatorSkip,
  navigatorLimit
} from '@/components/primitives/paginator/stored-navigator-store'

export default async ({ commit, state }, { eventId }) => {
  try {
    const params = {
      skip: navigatorSkip(state),
      limit: navigatorLimit(state),
      documentTypeId: state.formFilter.documentTypeId,
      description: state.formFilter.description
    }
    const { data } = await http.get(`/v1/documents/list-by-event/${eventId}`, { params })
    if (data.success) {
      const preparedList = data.list.map(d => ({
        ...d,
        submitState: 'REPOSE'
      }))
      commit('DOCUMENT_LIST', preparedList)
      commit('TOTAL_PAGE', data.countRows)
      return {
        list: preparedList,
        count: data.countRows
      }
    }
    return Promise.reject(Error('Não foi possível listar os documentos'))
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/event-documents/ListByEvent.js